import { FormattedMessage } from 'react-intl';

// assets
import AssignmentTwoToneIcon from '@mui/icons-material/AssignmentTwoTone';

// project imports
import { buildEntityTypeHierarchy } from 'store/app/workmgmt/entity-type-tree';

const buildTypeMenuChildren = (typeNodes = [], baseId = '', baseUrl = '') =>
    typeNodes.map((typeNode) => {
        const typeId = `${baseId}-${typeNode?.acronym?.toLowerCase()}`;
        const typeUrl = `/${baseUrl}/${typeNode?.acronym?.toLowerCase()}/list`;
        const childNodes = buildTypeMenuChildren(typeNode?.children || [], baseId, baseUrl);

        if (childNodes.length > 0) {
            return {
                id: typeId,
                title: typeNode?.name,
                type: 'collapse',
                icon: <AssignmentTwoToneIcon fontSize="small" />,
                children: childNodes
            };
        }

        return {
            id: typeId,
            title: typeNode?.name,
            type: 'item',
            url: typeUrl,
            icon: <AssignmentTwoToneIcon fontSize="small" />
        };
    });

export const buildBusinessOpportunitySideMenu = (busOppTypeList = []) => [
    {
        id: 'workmgmt-busopp',
        children: [
            {
                id: 'workmgmt-busopp-all',
                title: <FormattedMessage id="menuitems-workmgmt-busopp-all-title" />,
                type: 'item',
                url: '/workmgmt/busopp/list',
                icon: <AssignmentTwoToneIcon fontSize="small" />
            },
            ...buildTypeMenuChildren(
                buildEntityTypeHierarchy(busOppTypeList, 'businessOpportunityType'),
                'workmgmt-busopp',
                'workmgmt/busopp'
            )
        ]
    }
];

export const buildWorkOrderSideMenu = (workOrderTypeList = []) => [
    {
        id: 'workmgmt-workorder',
        children: [
            {
                id: 'workmgmt-workorder-all',
                title: <FormattedMessage id="menuitems-workmgmt-workorder-all-title" />,
                type: 'item',
                url: '/workmgmt/workorder/list',
                icon: <AssignmentTwoToneIcon fontSize="small" />
            },
            ...buildTypeMenuChildren(
                buildEntityTypeHierarchy(workOrderTypeList, 'workOrderType'),
                'workmgmt-workorder',
                'workmgmt/workorder'
            )
        ]
    }
];
